export const translationLivechat_sv_edit = {
  livechatEditMessage: "Redigera",
  livechatEditMessageLabel: "Redigera ditt svar",
  livechatEditMessageSave: "Spara",
  livechatEditMessageSaving: "Sparar...",
  livechatEditMessageCancel: "Avbryt",
  livechatEditMessageFailed: "Svaret kunde inte redigeras. Försök igen.",
  livechatEditMessageNoLongerEditable:
    "Svaret kan inte längre redigeras. Avbryt för att behålla det skickade svaret.",
  livechatMessageEdited: "redigerat",
};
